export default __webpack_public_path__ + "locales/fr/Profile.json?hash=7b9af6d497487e31456891ed35d306ea";